import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 0h-4c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h4c.6 0 1 .391 1 .978v13.686c0 .587-.4.978-1 .978h-4c-.6 0-1 .39-1 .977s.4.978 1 .978h4c1.7 0 3-1.27 3-2.933V2.933C20 1.271 18.7 0 17 0m-3.1 10.167c.1-.195.1-.489 0-.782-.1-.098-.1-.195-.2-.293l-5-4.888a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l3.3 3.226H1c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978h9.6L7.3 13.98a.93.93 0 0 0 0 1.368c.2.196.4.294.7.294s.5-.098.7-.294l5-4.888c.1-.097.2-.195.2-.293"
    }, null, -1)
  ]))]))
}
export default { render: render }